<fui-modal [maxHeight]="'650px'" [maxWidth]="'650px'" [state]="state">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()" [title]="'wbo.category.edit.heading.moveCategory'">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <fui-rows>
                <fui-row>
                    <fui-column>
                        <wbo-text-edit-control [value]="category?.name"
                                               [readonly]="true"
                                               label="wbo.category.search.field.moveCategory.category.label"
                                               placeholder="wbo.category.search.field.moveCategory.category.placeholder">
                        </wbo-text-edit-control>
                        <wbo-category-single-select-edit-control
                            [(ngModel)]="targetCategoryId"
                            [ngModelOptions]="{standalone: true}"
                            [clearSelectionOptionLabel]="'wbo.category.search.field.moveCategory.targetCategory.placeholder'"
                            label="wbo.category.search.field.moveCategory.targetCategory.label"
                            placeholder="wbo.category.search.field.moveCategory.targetCategory.placeholder"></wbo-category-single-select-edit-control>
                    </fui-column>
                </fui-row>
            </fui-rows>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button (click)="confirm()"
                               [title]="'wbo.common.button.apply'"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
